
<div *ngIf="loading() && !accountantConfigurations()" class="main-container d-flex justify-content-center align-items-center">
    <app-progress-spinner>
    </app-progress-spinner>
</div>

<div *ngIf="(!loading() && !accountantConfigurations()) || (!loading() && accountantConfigurations().length === 0)" class="main-container">
    <div class="w-100 h-100 d-flex justify-content-center align-items-center">
        <app-emptysate></app-emptysate>
    </div>
</div>

<div *ngIf="!loading() && accountantConfigurations() && accountantConfigurations()?.length !== 0" class="input-group mb-2">
  <span class="input-group-text fa-solid fa-magnifying-glass" id="basic-addon1"></span>
  <textarea [(ngModel)]="searchBarContent" rows="1" class="form-control" placeholder="Nome do App ou Id(s) do contador — separe múltiplos por vírgula, espaço ou quebra de linha"></textarea>
  <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">{{selectedFilter.mode.label}}</button>
  <ul class="dropdown-menu">
      <li>
          <button *ngFor="let filterMode of listFilterMode" (click)="changeFilter(filterMode.mode.value)" class="dropdown-item">{{filterMode.mode.label}}</button>
      </li>
  </ul>

  <div class="container-fluid mt-2">
      <div class="row justify-content-center">
          <div class="col-md-2">
              <div class="card mb-3">
                  <div class="card-body text-center">
                      <h5 class="card-title">Total</h5>
                      <h6 class="card-subtitle mb-2 text-muted">{{ accountantConfigurations() | sortWhitelabelAppsByType:selectedFilter.mode.value | totalAllCount }}</h6>
                    </div>
              </div>
          </div>
            <div class="col-md-2">
                <div class="card mb-3">
                    <div class="card-body text-center">
                        <h5 class="card-title">Publicado</h5>
                        <h6 class="card-subtitle mb-2 text-muted">{{ accountantConfigurations() | sortWhitelabelAppsByType:selectedFilter.mode.value | totalPublishedCount }}</h6>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="card mb-3">
                    <div class="card-body text-center">
                        <h5 class="card-title">Não Publicado</h5>
                        <h6 class="card-subtitle mb-2 text-muted">{{ accountantConfigurations() | sortWhitelabelAppsByType:selectedFilter.mode.value | totalUnpublishedCount }}</h6>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="card mb-3">
                    <div class="card-body text-center">
                        <h5 class="card-title">IOS Publicado</h5>
                        <h6 class="card-subtitle mb-2 text-muted">{{ accountantConfigurations() | sortWhitelabelAppsByType:selectedFilter.mode.value | totalIosPublishedCount }}</h6>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="card mb-3">
                    <div class="card-body text-center">
                        <h5 class="card-title">Android Publicado</h5>
                        <h6 class="card-subtitle mb-2 text-muted">{{ accountantConfigurations() | sortWhitelabelAppsByType:selectedFilter.mode.value | totalAndroidPublishedCount }}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>

<div *ngIf="selectedCount > 0" class="d-flex justify-content-end align-items-center gap-2 mb-2 w-100">
    <span class="text-muted">{{ selectedCount }} app(s) selecionado(s)</span>
    <button type="button" class="btn btn-primary" (click)="onRunBatch()">
        <i class="fa-solid fa-play me-1"></i> Subir selecionados em paralelo
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="clearSelection()">Limpar seleção</button>
</div>

<table *ngIf="!loading() && accountantConfigurations() && accountantConfigurations()?.length!== 0" class="table">
    <thead>
        <tr>
            <th class="text-center" scope="col">
                <input type="checkbox" class="form-check-input" [checked]="allDisplayedSelected" (change)="toggleSelectAll()" matTooltip="Selecionar todos">
            </th>
            <th scope="col">Nome do App</th>
            <th class=text-center>Cor Configurada</th>
            <th class="text-center" scope="col">Versão de Marketing</th>
            <th class="text-center" scope="col">Versão de Build</th>
            <th class="text-center" scope="col">Android</th>
            <th class="text-center" scope="col">iOS</th>
            <th class="text-center" scope="col">Data de Expiração do Certificado iOS</th>
            <th class="text-center"></th>
        </tr>
    </thead>
    
    <tbody>
      <tr *ngFor="let appConfig of accountantConfigurations() | filterApp:searchBarContent | alphabeticalSort | sortWhitelabelAppsByType:selectedFilter.mode.value; let i = index">
          <td class="text-center">
              <input *ngIf="isSelectable(appConfig)" type="checkbox" class="form-check-input" [checked]="isSelected(appConfig)" (change)="toggleSelection(appConfig)">
          </td>
          <td>
              {{ appConfig.name }}
              <span *ngIf="appConfig.isDraft" class="badge bg-primary">Rascunho</span>
          </td>
          <td class="text-center">
              <i *ngIf="appConfig.styles?.accentColor" class="me-2 fa-solid fa-check"></i>
          </td>
          <td class="text-center">{{ appConfig.versions?.versionName }}</td>
          <td class="text-center">{{ appConfig.versions?.versionCode }}</td>

          <td class="text-center">
            <span *ngIf="appConfig.android" class="d-inline-flex align-items-center">
              <i class="fa-solid fa-check me-2"></i>
              <i *ngIf="appConfig.android?.status === 1" class="fa-solid fa-upload" matTooltip="Publicado"></i> 
            </span>
          </td>
          
          <td class="text-center">
            <span *ngIf="appConfig.ios" class="d-inline-flex align-items-center">
              <i class="fa-solid fa-check me-2"></i>
              <i *ngIf="appConfig.ios?.status === 1" class="fa-solid fa-upload" matTooltip="Publicado"></i>
            </span>
          </td>
          
          <td class="text-center">
            {{ isValidDate(appConfig.ios?.iosCertificateExpiryDate) ? (appConfig.ios?.iosCertificateExpiryDate | date: 'dd/MM/yyyy') : 'Data inválida' }}
          </td>          

            <td class="text-center">
              <i *ngIf="!appConfig.isDraft" (click)="onRun(appConfig)" [class.d-none]="!appConfig.hasIos() && !appConfig.hasAndroid()" matTooltipPosition="above" matTooltip="Criar/atualizar"  class="whitelabel-action fa-solid fa-play"></i>
          </td>
          <td class="text-center">
              <!-- <a class="text-black" [queryParams]="{edit: true}" [routerLink]="['/whitelabel/create']" [state]="appConfig"> -->
              <a class="text-black" [routerLink]="['/whitelabel/edit/', appConfig.accountantId]">
                  <i matTooltipPosition="above" matTooltip="Editar" class="whitelabel-action fa-solid fa-pen-to-square"></i>
              </a>
          </td>
      </tr>
  </tbody>
</table>
